import { Center } from '@/types/models'
import { isPPV } from '@/domain/center'
import { isNonEmptyArray } from '@/utils/checks'

const areAllCentersSponsor = (centers: Center[] = []): boolean => {
  return isNonEmptyArray(centers) && centers.every((center) => isPPV(center))
}

export default areAllCentersSponsor
